import { styled } from "styled-components";

export const PayTypeWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  > .pay-title {
    font-family: Pretendard;
    font-size: 20px;
    font-weight: 600;
    text-align: left;
  }

  input:focus {
    border-color: #e5e5e5;
    outline: none;
  }
`;

export const PayTypeContent = styled.div<{ isWide: boolean }>`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: ${({ isWide }) => (isWide ? "44px" : "20px")};
  row-gap: 12px;
`;

export const PayTypeItem = styled.div<{ isWide: boolean; $isHover?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ isWide }) => (isWide ? "10px" : "5px")};
  width: 100%;

  > .name {
    flex: 1;
    font-family: Pretendard;
    font-size: 14.67px;
    font-weight: 500;
    text-align: center;
    cursor: pointer;
    color: ${({ $isHover }) => ($isHover ? "#fff" : "#121212")};
    background: ${({ $isHover }) => ($isHover ? "#6436E7" : "#fff")};
    display: flex;
    height: 34px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 9.78px;
    min-width: ${({ isWide }) => (isWide ? "99px" : "auto")};
  }

  > input {
    width: ${({ isWide }) => (isWide ? "110px" : "80px")};
    height: 34px;
    border-radius: 9.78px;
    border: 1px solid #e5e5e5;
    line-height: 34px;
    font-family: Pretendard;
    font-size: 14.67px;
    font-weight: 500;
    text-align: center;
    box-sizing: border-box;
  }
`;
